import { render, staticRenderFns } from "./BarraSuperior.vue?vue&type=template&id=5ba6a8ab&scoped=true&"
import script from "./BarraSuperior.vue?vue&type=script&lang=ts&"
export * from "./BarraSuperior.vue?vue&type=script&lang=ts&"
import style0 from "./BarraSuperior.vue?vue&type=style&index=0&id=5ba6a8ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6a8ab",
  null
  
)

export default component.exports